<template>
  <div>
    <div class="p-5 overflow-auto max-h-[70vh]">
      <div>
        <div>
          <div class="flex justify-between mb-4">
            <div>
              <p>
                <span v-if="this.orgData?.plan_name" class="font-bold"
                  >Plan Name :-
                </span>
                <span>
                  {{ this.orgData?.plan_name }}
                </span>
                <span class="status_color">[ {{ this.orgData?.status }} ]</span>
              </p>
              <p>
                <span class="font-bold">Validity :-</span> {{ is_valid_from }} -
                {{ is_valid_to }}
              </p>
              <v-btn
                @click="toggleShowAll"
                small
                outlined
                class="font-semibold"
                v-show="limitations !== true"
                disabled
              >
                Organization Limitations <v-icon>mdi-link-variant</v-icon>
              </v-btn>
              <v-navigation-drawer v-model="drawer" right temporary app>
                <v-toolbar flat>
                  <h4>Organization Limitations</h4>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="toggleShowAll">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-item v-for="(value, key) in limitations" :key="key">
                    <v-list-item-content>
                      <v-list-item-title class="font-bold"
                        >{{ convertTitle(key) }}: {{ value }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-navigation-drawer>
            </div>
            <div>
              <QRCode :qrValue="qrValue" />
            </div>
          </div>
          <v-list>
            <v-list-item-group>
              <v-row>
                <v-list-item
                  v-for="(label, key, index) in use_cases"
                  :key="key"
                  class="space-x-4 border border-blue-200"
                >
                  <v-label class=""> {{ index + 1 }}. </v-label>
                  <v-col>
                    <v-checkbox
                      :color="$vuetify.theme.currentTheme.primary"
                      :label="label"
                      :value="key"
                      v-model="selectedUseCases"
                      readonly
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="9">
                    <v-chip
                      v-for="(chip, index) in extractSubCases(key)"
                      :key="index"
                      label
                      small
                      class="border border-black mr-2 mb-1"
                    >
                      <span class="pr-2 text-black">
                        {{ chip }}
                      </span>

                      <v-icon
                        v-if="canEditOrDeleteSubCase(key, chip)"
                        small
                        @click="removeSubCaseChip(chip)"
                        color="red"
                        class="ml-2"
                        v-tooltip="{
                          text: 'Delete',
                        }"
                      >
                        $delete
                      </v-icon>

                      <v-icon
                        v-if="canEditOrDeleteSubCase(key, chip)"
                        small
                        @click="editItem(chip, index, key)"
                        color="green"
                        class="ml-2"
                        v-tooltip="{
                          text: 'Edit',
                        }"
                      >
                        $edit
                      </v-icon>

                      <v-icon
                        v-if="canEditOrDeleteSubCase(key, chip)"
                        small
                        @click="cloneSubCaseChip(chip, index, key)"
                        color="blue"
                        class="ml-2"
                        v-tooltip="{
                          text: 'Clone',
                        }"
                      >
                        mdi-content-copy
                      </v-icon>
                    </v-chip>
                  </v-col>

                  <v-col cols="1">
                    <div class="flex justify-end" v-if="key === 'COLLECTION'">
                      <v-btn
                        text
                        :color="$vuetify.theme.currentTheme.primary"
                        @click="handleOrgMapping(key)"
                        >Create Case</v-btn
                      >
                    </div>
                  </v-col>
                </v-list-item>
              </v-row>
            </v-list-item-group>
          </v-list>
        </div>
      </div>
    </div>
    <v-dialog v-model="openOrgMapping" max-width="63rem" persistent>
      <OrgMapping
        :useCase="mappedUseCase"
        @cancel="onCancelOrgMapping"
        @orgMapKeys="handleMapKeys"
        :enabledSubCases="enabledSubCases"
        :editSubCase="editSubCase"
        :cloneSubCase="cloneSubCase"
        :allowedQuestionsTypes="receivedData?.allowedQuestionTypes"
        :allowedQuestionsTypesCustomerFeedback="
          receivedData?.allowedQuestionTypesCustomerFeedback
        "
      />
    </v-dialog>
    <AlertPopUp
      :showConfirmationDialog="showDeleteSubCaseDialog"
      :confirmationTitle="'Confirm Delete'"
      :confirmationMessage="'Are you sure you want to delete the case?'"
      :confirmationActionText="'DELETE'"
      :confirmationActionColor="'red'"
      :performAction="deleteSubCase"
      :cancel="cancel"
    />
  </div>
</template>
<script>
import OrgMapping from "../OrgMapping";
import AlertPopUp from "@/components/AlertPopUp";
import QRCode from "./qrCode.vue";
import { convertToTitleCase } from "@/utils/common";
import { cloneDeep } from "lodash";
export default {
  data() {
    return {
      use_cases: {},
      selectedUseCases: [],
      enabledSubCases: [],
      selectedChip: null,
      showDeleteSubCaseDialog: false,
      openOrgMapping: false,
      mappedUseCase: "",
      editSubCase: null,
      cloneSubCase: null,
      qrCode: "",
      orgData: this.$storage.getUniversal("orgData"),
      orgCode: this.$storage.getUniversal("organization_code"),
      userOrg: this.$storage.getUniversal("user"),
      qrValue: `${process.env.VUE_APP_BASE_URL}/mark-attendance?orgCode=${this.orgCode}`,
      drawer: false,
    };
  },
  components: {
    OrgMapping,
    AlertPopUp,
    QRCode,
  },
  props: {
    receivedData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    receivedData(newVal) {
      if (newVal !== null) {
        this.populateFields(newVal);
      }
    },
  },
  methods: {
    convertTitle(str) {
      return convertToTitleCase(str);
    },
    extractSubCases(useCaseKey) {
      const enabledSubCasesForUseCase = this.enabledSubCases?.find(
        (sub) => sub.useCase === useCaseKey.toLowerCase()
      );

      if (!enabledSubCasesForUseCase) {
        return [];
      }

      const subCasesName = enabledSubCasesForUseCase.subCase.map(
        (sub) => sub.name
      );

      return subCasesName;
    },
    canEditOrDeleteSubCase(useCaseKey, subCaseName) {
      const { branch, role } = this.userOrg || {};
      const enabledSubCasesForUseCase = this.enabledSubCases?.find(
        (sub) => sub.useCase === useCaseKey.toLowerCase()
      );

      if (role?.includes("WFM_ADMIN") || !branch) {
        return true;
      }

      const matchingSubCase = enabledSubCasesForUseCase?.subCase.find(
        (sub) => sub.name === subCaseName && sub.branch === branch
      );

      return !!matchingSubCase;
    },
    removeSubCaseChip(chipName) {
      this.selectedChip = chipName;
      this.showDeleteSubCaseDialog = true;
      this.$emit("subCases", this.enabledSubCases);
    },
    cloneSubCaseChip(chipName, indx, key) {
      for (let i = 0; i < this.enabledSubCases.length; i++) {
        const subCase = this.enabledSubCases[i];
        const selectedSubCase = subCase.subCase.find(
          (item) => item.name === chipName
        );

        if (selectedSubCase) {
          this.cloneSubCase = cloneDeep(selectedSubCase);
          this.cloneSubCase.cloneIndex = indx;
        }
      }

      this.openOrgMapping = true;
      this.mappedUseCase = key;
    },
    deleteSubCase() {
      for (let i = 0; i < this.enabledSubCases.length; i++) {
        const subCase = this.enabledSubCases[i];
        const index = subCase.subCase.findIndex(
          (item) => item.name === this.selectedChip
        );
        if (index !== -1) {
          subCase.subCase.splice(index, 1);
          if (subCase.subCase.length === 0) {
            this.enabledSubCases.splice(i, 1);
          }
          break;
        }
      }
      this.showDeleteSubCaseDialog = false;
      this.$emit("subCases", this.enabledSubCases);
    },
    editItem(chipName, indx, key) {
      for (let i = 0; i < this.enabledSubCases.length; i++) {
        const subCase = this.enabledSubCases[i];
        const selectedSubCase = subCase.subCase.find(
          (item) => item.name === chipName
        );

        // Creating a deep copy of selectedSubCase using Lodash
        if (selectedSubCase) {
          this.editSubCase = cloneDeep(selectedSubCase);
          this.editSubCase.indx = indx;
        }
      }

      this.openOrgMapping = true;
      this.mappedUseCase = key;
      this.$emit("subCases", this.enabledSubCases);
    },
    cancel() {
      this.showDeleteSubCaseDialog = false;
      this.showdDeleteAllDialog = false;
      this.selectedChip = null;
    },
    handleOrgMapping(key) {
      this.mappedUseCase = key;
      this.editSubCase = null;
      this.openOrgMapping = true;
    },
    onCancelOrgMapping() {
      this.openOrgMapping = false;
      this.cloneSubCase = {};
      this.editSubCase = {};
    },
    handleMapKeys(keys) {
      this.enabledSubCases = keys;
      this.openOrgMapping = false;
      this.cloneSubCase = {};
      this.editSubCase = {};
      this.$emit("subCases", this.enabledSubCases);
    },
    populateFields(val) {
      this.selectedUseCases = val?.enabledUseCases?.map(
        (el) => el.toUpperCase() || []
      );
      this.selectedUseCases?.forEach((el) => {
        this.use_cases[el.toUpperCase()] = el.toLowerCase();
      });
      this.enabledSubCases = val?.enabledSubCases;
    },
    toggleShowAll() {
      this.drawer = !this.drawer;
    },
  },
  async mounted() {
    this.populateFields(this.receivedData);
  },
  computed: {
    is_valid_from() {
      return this.$dayjs(this.orgData?.valid_from).format("MMMM D, YYYY");
    },
    is_valid_to() {
      return this.$dayjs(this.orgData?.valid_to).format("MMMM D, YYYY");
    },
    limitations() {
      return this.orgData.plan_limitations;
    },
  },
};
</script>
<style scoped>
.status_color {
  color: #33cc33;
}
.chipContainer {
  display: flex;
  flex-wrap: wrap;
}
</style>
